import './Event.scss'

import useCurrentTime from "../../../hooks/CurrentTimeHook"
import EventParticipants from "../../modals/EventParticipants/EventParticipants"
import { formattedDateTime } from "../../../utilities/datetime"
import { useCharacters } from '../../../contexts/Characters'
import { useModal } from '../../../contexts/Modal'
import { useData } from '../../../contexts/Data'

const Event = ({ event, scope = event.scope, writable }) => {
    const currentTime = useCurrentTime()
    const characters = useCharacters()
    const modal = useModal()
    const data = useData()
    
    const showEventParticipants = (htmlEvent, participants) => {
        htmlEvent.stopPropagation()
        modal.open({ title: 'Event Participants', component: <EventParticipants />, data: { participants } })
    }

    return (
        <div className={`card event ${writable ? 'clickable' : 'dull'} ${(event.endDate || event.startDate) < currentTime ? 'past' : ''} ${event.startDate < currentTime && event.endDate && event.endDate > currentTime ? 'ongoing' : ''}`}>
            <div className="row align-items-center">
                {data.$state.eventTypes && <h4 className="col name mb-3">{data.$state.eventTypes[scope].find((type) => type.name === event.type)?.label}</h4>}
                <div className="col-md-auto">
                    <div className="card semi-dark participants flex-center-y mb-3 px-3 py-0" onClick={event.participantsType === 'custom' ? (htmlEvent) => showEventParticipants(htmlEvent, event.participants) : null}>
                        <span className="mr-2">{`${event.participantsType === 'custom' ? `${event.participants.length} `: ''}Participants:`}</span>
                        {event.participantsType === 'all' ? 'everyone' : (
                            <div className="d-flex">
                                <ul className="participants-list d-flex">
                                    {event.participants.filter((character) => character._id !== characters.$state.current._id).slice(0, 3).map((character) => (
                                        <li className="participant flex-center" key={character._id}>
                                            {character.name[0]}
                                        </li>
                                    ))}
                                    {event.participants.some((character) => character._id === characters.$state.current._id) && (
                                        <li className="participant flex-center self">{characters.$state.current.name[0]}</li>
                                    )}
                                </ul>
                                {event.participantsType === 'custom' && event.participants.filter((character) => character._id !== characters.$state.current._id).length > 3 && (
                                    <span className="more align-self-end">...</span>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="row justify-content-between">
                <div className="col">{formattedDateTime(event.startDate).split(' ').map((datetimePart, index) => (
                    <p className={`my-1 ${index ? 'font-weight-bold' : ''}`} key={datetimePart}>{datetimePart}</p>
                ))}</div>

                {event.endDate && (
                    <>
                        <div className="col-auto flex-center-y">
                            <div className="icon-container sm">
                                <img src="/images/icons/arrow_right.svg" />
                            </div>
                        </div>
                        <div className="col text-right">{formattedDateTime(event.endDate).split(' ').map((datetimePart, index) => (
                            <p className={`my-1 ${index ? 'font-weight-bold' : ''}`} key={datetimePart}>{datetimePart}</p>
                        ))}</div>
                    </>
                )}
            </div>
            {event.notes && (
                <>
                    <hr className="my-3" />
                    <p className="mt-3">{event.notes}</p>
                </>
            )}
        </div>
    )
}

export default Event